module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('multiselect', {
    staticClass: "multiselect",
    attrs: {
      "options": (!_vm.searchQuery || _vm.isISBN) ? [] : _vm.titres,
      "internal-search": false,
      "loading": _vm.isLoading,
      "allow-empty": true,
      "close-on-select": true,
      "id": "ajax",
      "label": "titre",
      "track-by": "id",
      "placeholder": "Rechercher un livre",
      "block-keys": ['Tab', 'Enter']
    },
    on: {
      "search-change": _vm.updateSearchQuery,
      "select": _vm.selectBook,
      "close": _vm.resetSearchQuery
    },
    scopedSlots: _vm._u([
      ["noResult", function(props) {
        return [(_vm.isISBN) ? _c('button', {
          staticClass: "button",
          attrs: {
            "type": "button"
          },
          on: {
            "mousedown": function($event) {
              $event.stopPropagation();
              _vm.selectISBN($event)
            }
          }
        }, [_vm._v("Chercher par ce ISBN")]) : (_vm.isLoading) ? _c('span', [_vm._v("Robert cherche...")]) : _c('span', [_vm._v("Livre introuvable")])]
      }],
      ["option", function(props) {
        return [_c('search-item-book', {
          staticClass: "searchitembook",
          class: {
            '-is-loading': _vm.isLoading
          },
          attrs: {
            "titre": props.option,
            "id": props.option.livres.length && props.option.livres[0].id
          }
        })]
      }]
    ])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6428b231"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search-input.vue
// module id = 1363
// module chunks = 1